import { ArrowUpRight } from "lucide-react";
import { site } from "@/data/site";
import { Reveal } from "./Reveal";

export const ExploreLocations = () => {
    const go = () =>
        document.querySelector("#consultation")?.scrollIntoView({
            behavior: "smooth",
        });

    return (
        <section
            id="locations"
            data-testid="locations-section"
            className="bg-stone px-6 py-16 lg:px-10 lg:py-24"
        >
            <div className="mx-auto max-w-[1400px]">
                <Reveal>
                    <div className="mb-14 flex flex-col justify-between gap-6 lg:mb-20 lg:flex-row lg:items-end">
                        <div>
                            <span className="eyebrow">Explore By Location</span>
                            <h2 className="mt-5 max-w-2xl font-serif text-4xl leading-[1.08] tracking-tight text-charcoal sm:text-5xl">
                                Mumbai's most coveted postcodes.
                            </h2>
                        </div>
                        <p className="max-w-sm text-base leading-relaxed text-slatey">
                            From the seafront to the business heart of the city —
                            discover where your next address belongs.
                        </p>
                    </div>
                </Reveal>

                <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3 lg:gap-8">
                    {site.locations.map((l, i) => (
                        <Reveal key={l.name} delay={(i % 3) * 0.09}>
                            <button
                                data-testid={`location-${i}`}
                                onClick={go}
                                className="group relative block h-80 w-full overflow-hidden border border-line text-left"
                            >
                                <img
                                    src={l.image}
                                    alt={l.name}
                                    loading="lazy"
                                    className="absolute inset-0 h-full w-full object-cover transition-transform duration-[1600ms] ease-out group-hover:scale-110"
                                />
                                <div className="absolute inset-0 bg-gradient-to-t from-charcoal/80 via-charcoal/15 to-transparent" />
                                <div className="absolute inset-x-0 bottom-0 flex items-end justify-between p-7">
                                    <div>
                                        <h3 className="font-serif text-3xl text-white">
                                            {l.name}
                                        </h3>
                                        <p className="mt-1 text-sm text-white/80">
                                            {l.note}
                                        </p>
                                    </div>
                                    <span className="flex h-10 w-10 items-center justify-center rounded-full border border-white/50 text-white transition-colors duration-300 group-hover:bg-orange group-hover:border-orange">
                                        <ArrowUpRight size={18} />
                                    </span>
                                </div>
                            </button>
                        </Reveal>
                    ))}
                </div>
            </div>
        </section>
    );
};
